import React from 'react';
import PDFHeader from './PDFHeader';
import { ItineraryItem } from '../../types/Quotation';
import FlightCard from './FlightCard';
import HotelCard from './HotelCard';
import TransferCard from './TransferCard';
import ActivityCard from './ActivityCard';

interface PDFPage2Props {
  highlightImages: string[];
  inclusionImages: string[];
  itinerary: ItineraryItem[];
}

const PDFPage2: React.FC<PDFPage2Props> = ({ highlightImages, inclusionImages, itinerary }) => (
  <div className="pdf-page">
    <PDFHeader />
    <section className="pdf-section">
      <h2>Inclusions</h2>

      {/* Optional illustrative images at top */}
      {(highlightImages.length > 0 || inclusionImages.length > 0) && (
        <div>
          {highlightImages.length > 0 && (
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>Highlights</div>
              {highlightImages.map((src, idx) => (
                <img key={idx} src={src} alt={`highlight-${idx}`} style={{ maxWidth: '100%', margin: '6px 0', borderRadius: 6 }} />
              ))}
            </div>
          )}
          {inclusionImages.length > 0 && (
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>Gallery</div>
              {inclusionImages.map((src, idx) => (
                <img key={idx} src={src} alt={`inclusion-${idx}`} style={{ maxWidth: '100%', margin: '6px 0', borderRadius: 6 }} />
              ))}
            </div>
          )}
        </div>
      )}

      {/* Included services */}
      {itinerary.some(day => (day.flights || []).length > 0) && (
        <div style={{ marginTop: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <span style={{ fontSize: 20 }}>✈️</span>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: '600', color: '#2c3e50' }}>Flights</h3>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {itinerary.flatMap((day, dayIndex) =>
              day.flights.map((flight, flightIndex) => (
                <FlightCard key={`${dayIndex}-${flightIndex}`} flight={{ ...flight, day: day.day }} />
              ))
            )}
          </div>
        </div>
      )}

      {itinerary.some(day => (day.hotels || []).length > 0) && (
        <div style={{ marginTop: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <span style={{ fontSize: 20 }}>🏨</span>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: '600', color: '#2c3e50' }}>Hotels</h3>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {(() => {
              const seen = new Set<string>();
              const list: any[] = [];
              itinerary.forEach((day) => {
                (day.hotels || []).forEach((hotel) => {
                  const key = String((hotel as any).hotelId || hotel.name || '').toLowerCase();
                  if (!key || seen.has(key)) return;
                  seen.add(key);
                  list.push({ ...hotel, day: day.day });
                });
              });
              return list.map((hotel, idx) => (
                <HotelCard key={idx} hotel={hotel} />
              ));
            })()}
          </div>
        </div>
      )}

      {itinerary.some(day => (day.transfers || []).length > 0) && (
        <div style={{ marginTop: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <span style={{ fontSize: 20 }}>🚗</span>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: '600', color: '#2c3e50' }}>Transfers</h3>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {itinerary.flatMap((day, dayIndex) =>
              (day.transfers || []).map((transfer, transferIndex) => (
                <TransferCard key={`${dayIndex}-${transferIndex}`} transfer={{ ...transfer, day: day.day }} />
              ))
            )}
          </div>
        </div>
      )}

      {itinerary.some(day => (day.activities || []).length > 0) && (
        <div style={{ marginTop: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <span style={{ fontSize: 20 }}>🎟️</span>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: '600', color: '#2c3e50' }}>Activities</h3>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {itinerary.flatMap((day, dayIndex) =>
              (day.activities || []).map((activity, activityIndex) => (
                <ActivityCard key={`${dayIndex}-${activityIndex}`} activity={{ ...activity, day: day.day }} />
              ))
            )}
          </div>
        </div>
      )}
    </section>
  </div>
);

export default PDFPage2;
